module.exports = __webpack_public_path__ + "media/images/icon_sidebar_category-49d16f4e4dadacec7c995111b684b1be.svg";